import { useQuery } from '@tanstack/react-query'
import { getInquiries } from '@/lib/apiClients/inquiries'
import { queryKeys } from '@/lib/queryKeys'

export function useInquiries() {
  return useQuery({
    queryKey: queryKeys.inquiries.all(),
    queryFn: async () => {
      const result = await getInquiries()
      if (!result) return result
      return {
        ...result,
        inquiries: [...result.inquiries].sort((a, b) => {
          return b.updated_at - a.updated_at
        }),
      }
    },
  })
}
